import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ApiService } from './api.service';
import { ListService } from './list.service';
import { PortalDataDashboardGlobalIndicatorModel } from '../models/portal-data-dashboard-global-indicator.model';

@Injectable({
  providedIn: 'root',
})
export class PortalDataDashboardGlobalIndicatorService extends ListService {
  protected dataSubject =
    new BehaviorSubject<PortalDataDashboardGlobalIndicatorModel>({
      countriesDeployedNb: 0,
      deviceList: [],
      pointOfSalesNb: 0,
    });
  public data$ = this.dataSubject.asObservable();

  constructor(public _apiService: ApiService) {
    super();
  }

  getList(): Observable<PortalDataDashboardGlobalIndicatorModel> {
    return this._apiService
      .get<PortalDataDashboardGlobalIndicatorModel>(
        'portal-data-dashboard-global-indicator'
      )
      .pipe(tap(response => this.dataSubject.next(response)));
  }

  refreshData() {
    this.getList().subscribe();
  }
}
